import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Link, useParams} from 'react-router-dom';
import {
  chevronRight,
  deleteIc,
  dropdownBlue,
  dropdownGrey,
  easyOnboardIc,
  edit,
  lookupEmpty,
} from '../../../assets/images/images';
import {
  DashboardLayout,
  EmptyState,
  Loader,
  PrimaryButton,
  // SearchInput,
  TableLayout,
} from '../../../components';
import * as Actions from '../../../store/actions';
import {Constants, capitalizeEveryWord} from '../../../helpers';
import AddToListModal from './AddToListModal';
import moment from 'moment/moment';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';

function FraudDetectionFlows({
  updateList,
  getList,
  caseLists: {listLoading, mutateLoading, list},
}) {
  const {slug} = useParams();
  const [addToListModal, setOpenAddToListModal] = useState(false);
  const [listItems, setListItems] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const {_id, __v, company, createdAt, count, updatedAt, ...data} = list || {};

  useEffect(() => {
    getList(slug);
  }, [getList, slug]);

  useEffect(() => {
    list && setListItems([...((list?.items && list?.items) || [])]);
  }, [list]);

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Custom Lists</p>
      }
    >
      {' '}
      <div className="flex items-center justify-between py-2 flex-wrap gap-3 mx-[-32px] px-8 border border-transparent border-b-[#E4E3EC]">
        <Breadcrumbs
          items={[
            {label: 'Custom Lists', path: PAGES_URL.CUSTOM_LISTS},
            {
              label: `${capitalizeEveryWord(list?.name ?? '...')}`,
            },
          ]}
        />

        <PrimaryButton
          buttonText="Add to list"
          onClick={() => setOpenAddToListModal(true)}
        />
      </div>
      <AddToListModal
        lists={listItems}
        listData={{...data}}
        open={addToListModal}
        setOpen={setOpenAddToListModal}
        updateList={updateList}
        setListItems={setListItems}
        loading={mutateLoading}
      />
      {listLoading ? (
        <Loader />
      ) : !listLoading && listItems?.length === 0 ? (
        <EmptyState
          buttonText="Create a new list"
          onClick={() => setOpenAddToListModal(true)}
          body="No list has been created yet, to get started click on the button below"
          maxWidth="max-w-[226px]"
          src={lookupEmpty}
        />
      ) : (
        <section className="flex flex-col">
          <TableLayout negativeMargins>
            <thead className="font-semibold uppercase">
              <tr className="bg-white80">
                <th className="pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap">
                  <div className="flex items-end gap-1">
                    <span>name</span>
                  </div>
                </th>
                <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                  <div className="flex items-end gap-1">
                    <span>date created</span>
                  </div>
                </th>
                <th className="min-w-[175px]"></th>
              </tr>
            </thead>
            <tbody className="text-sm bg-white">
              {list &&
                listItems?.map((item, i) => (
                  <tr
                    key={i}
                    className="border-[0.5px] border-[#E4E3EC] cursor-pointer"
                  >
                    <td className="p-4 pl-4 sm:pl-6 xl:pl-8 text-body whitespace-nowrap capitalize">
                      {item.length > 30 ? `${item.substring(0, 30)}...` : item}
                    </td>
                    <td className="p-4 pl-0 text-body whitespace-nowrap">
                      {moment(list?.createdAt).format('Do MMMM YYYY hh:mm')}
                    </td>
                    <td className="p-4 pl-0 text-body whitespace-nowrap relative">
                      <div className="flex items-center gap-6 z-2 p-5 absolute top-0">
                        <button
                          onClick={() => setOpenAddToListModal(true)}
                          title="Edit"
                        >
                          <img src={edit} alt="" width={16} height={16} />
                        </button>
                        <button
                          onClick={() => {
                            const allList = [...listItems];
                            const updatedList = allList.filter(
                              list => list !== item,
                            );
                            setListItems(updatedList);
                            setTimeout(() => {
                              updateList({
                                listId: slug,
                                ...data,
                                items: updatedList,
                              });
                            }, 1000);
                          }}
                          title="Delete"
                        >
                          <img src={deleteIc} alt="" width={16} height={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TableLayout>
        </section>
      )}
    </DashboardLayout>
  );
}
export default connect(state => state, Actions)(FraudDetectionFlows);
